import { isPostHogExcludedUserId } from "@/lib/analytics/excluded-users";
import { shutdownPostHogForExcludedUser } from "@/lib/analytics/opt-out-excluded";

let activeUserId: string | null = null;

/** Authenticated codex_users.id for runtime analytics guards (client-only). */
export function getAnalyticsSessionUserId(): string | null {
  return activeUserId;
}

export function setAnalyticsSessionUserId(userId: string | null): void {
  activeUserId = userId?.trim() || null;

  if (activeUserId && isPostHogExcludedUserId(activeUserId)) {
    shutdownPostHogForExcludedUser();
  }
}

export function clearAnalyticsSessionUserId(): void {
  activeUserId = null;
}
